import axios from 'axios'
import router from './router/CareRingsRouter.js'
import store from './store/index.js'
const http = axios.create({
  // for cors
  withCredentials: true
})
http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response.status) {
      // 認証エラー時の処理
      if (error.response.status === 401) {
        if (location.pathname.match('/master')) {
          router.push('/Master/Pages')
          store.dispatch('systemAdminDefine/successLogoutFlag')
          store.dispatch('systemAdminDefine/changeUnauthorizedFlag')
        } else {
          router.push('/Pages')
          store.dispatch('masters/successLogoutFlag')
          store.dispatch('masters/changeUnauthorizedFlag')
        }
        // 権限エラー時の処理
      } else if (error.response.status === 403) {
        if (!location.pathname.match('/master')) {
          router.push('/Pages')
          store.dispatch('masters/successLogoutFlag')
          store.dispatch('masters/changeForbiddenFlag')
        }
      }
    }
    return Promise.reject(error)
  }
)

export default Vue => {
  Vue.http = http
  Object.defineProperties(Vue.prototype, {
    $http: {
      get() {
        return http
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/http.js